import React from "react";
import { motion } from "framer-motion";
import { oneAppliction, endTOEnd, instFunding } from "../../../assets/images";

const lenderCards = [
  {
    img: oneAppliction,
    title: "Your Gateway to Financial Freedom",
    desc: "Are you tired of endless loan applications and rejections? Our platform is your one-stop solution to explore prequalified offers from various lenders. Say goodbye to the hassle and hello to convenience!",
    className: "lender-first",
  },
  {
    img: endTOEnd,
    title: "Unlock Your Dreams with a Single Click",
    desc: "Get prequalified loan offers that are tailored to your needs right away. There is no effect on your credit score, no commitments, simply an endless array of options.",
    className: "lender-second",
  },
  {
    img: instFunding,
    title: "Funds at Your Doorstep, Quicker Than Ever",
    desc: "Experience instant funding with our leading lending partners. You can now have the funds directly deposited into your accounts within 24 hours of approval.",
    className: "lender-third",
  },
  {
    img: instFunding,
    title: "Personalized Solutions for Your Every Financial Need",
    desc: "Whether it's a business, personal, or professional loan, our platform will match you with the best lending program to meet your specific needs. We'll be there for you at every step of the journey.",
    className: "lender-fourth",
  },
  {
    img: instFunding,
    title: "Explore a World of Lending Options from Trusted Partners",
    desc: "Collaborate with reputable lenders governed by the RBI who will help you achieve your financial objectives. Choose from a wide range of loans that are suited to your goals and creditworthiness.",
    className: "lender-fifth",
  },
];

const LenderCard = ({ img, title, desc, className }) => (
  <motion.div
    className="col-lg-4 col-md-6 mb-4"
    initial={{ opacity: 0, x: -100 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.6, ease: "easeOut" }}
    viewport={{ once: true, amount: 0.2 }}
  >
    <div className={`lender-box ${className}`}>
      <img src={img} className="img-fluid" alt={title} loading="lazy" />
      <div className="lender-content">
        <h5>{title}</h5>
        <p>{desc}</p>
      </div>
    </div>
  </motion.div>
);

const LenderSection = () => {
  return (
    <section className="lender-section">
      <div className="container">
        <div className="lender-head text-center mb-5">
          <h2 className="green-border">
            Empowering Your Financial Future with Quick and Easy Loans
          </h2>
        </div>
        <div className="row">
          {lenderCards.slice(0, 3).map((card, i) => (
            <LenderCard key={i} {...card} />
          ))}
        </div>
        <div className="row second-row justify-content-center">
          {lenderCards.slice(3).map((card, i) => (
            <LenderCard key={i + 3} {...card} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LenderSection;
